export interface PortalBackgroundBranding {
  portalBackgroundColor?: string | null;
}

export function buildPortalBackgroundCssRules(
  _root: string,
  branding: PortalBackgroundBranding | null | undefined,
): string[] {
  const raw = branding?.portalBackgroundColor;
  const color = typeof raw === "string" && raw.length > 0 ? raw : undefined;
  if (color === undefined) {
    return [];
  }

  return [
    `[data-ui="select-items"] { background-color: ${color}; }`,
    `[data-ui="orderDetails"] { background-color: ${color}; }`,
    `[data-modalless-page] { background-color: ${color}; }`,
  ];
}
